var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Evaluaciones Admin"}},[_c('listaEvaluacionesDocente_2')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }